export class AlertaFilter {
	public nombre: string;
	public emisorId: string;
	public activo: boolean;
	public usuarioId: string;
}
